import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

import {
	PeriodDateType,
	PeriodUnitType,
	VestingTermTimeUnitType,
} from '@dealstack/shared/lib/generated';

export const makePeriodTimeUnitOptions = (
	tCommonUi: TranslateFunction<I18Namespaces.COMMON_UI>,
	onlyBaseValues?: boolean
) =>
	(onlyBaseValues
		? [PeriodUnitType.MONTHLY, PeriodUnitType.YEARLY]
		: Object.values(PeriodUnitType)
	).map((unitType) => ({
		label: getPeriodType(tCommonUi, unitType) ?? '',
		value: unitType,
	}));

export const getPeriodUnit = (
	tCommonUI: TranslateFunction<I18Namespaces.COMMON_UI>,
	periodType?: string,
	count?: number
) => {
	if (!periodType) {
		return;
	}
	let translation = '';

	if (periodType === VestingTermTimeUnitType.YEARLY) {
		translation = tCommonUI(`period.${count === 1 ? 'year' : 'years'}`);
	} else {
		translation = tCommonUI(`period.${count === 1 ? 'month' : 'months'}`);
	}

	return `${count || ''} ${translation}`.trim();
};

export const getPeriodType = (
	tCommonUI: TranslateFunction<I18Namespaces.COMMON_UI>,
	periodType?: string
) => {
	if (!periodType) {
		return;
	}

	switch (periodType) {
		case PeriodUnitType.DAILY:
			return tCommonUI('period.daily');
		case PeriodUnitType.MONTHLY:
			return tCommonUI('period.monthly');
		case PeriodUnitType.QUARTERLY:
			return tCommonUI('period.quarterly');
		case PeriodUnitType.YEARLY:
			return tCommonUI('period.yearly');
		default:
			return periodType;
	}
};

export const makePeriodTimeDateOptions = (tCommonUi: TranslateFunction<I18Namespaces.COMMON_UI>) =>
	Object.values(PeriodDateType).map((unitType) => ({
		label: getPeriodDateType(tCommonUi, unitType) ?? '',
		value: unitType,
	}));

export const getPeriodDateType = (
	tCommonUI: TranslateFunction<I18Namespaces.COMMON_UI>,
	periodType: PeriodDateType | undefined,
	count?: number
) => {
	if (!periodType) {
		return;
	}

	switch (periodType) {
		case PeriodDateType.DAYS:
			return tCommonUI(`period_type.${count === 1 ? 'day' : 'days'}`);
		case PeriodDateType.MONTHS:
			return tCommonUI(`period_type.${count === 1 ? 'month' : 'months'}`);
		case PeriodDateType.YEARS:
			return tCommonUI(`period_type.${count === 1 ? 'year' : 'years'}`);
		default:
			return periodType;
	}
};
